import { render, staticRenderFns } from "./adblock-modal.vue?vue&type=template&id=2a9dc86c&scoped=true"
import script from "./adblock-modal.vue?vue&type=script&lang=js"
export * from "./adblock-modal.vue?vue&type=script&lang=js"
import style0 from "./adblock-modal.vue?vue&type=style&index=0&id=2a9dc86c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9dc86c",
  null
  
)

export default component.exports